"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VuexConnector = (function () {
    function VuexConnector(store) {
        this.store = store;
    }
    VuexConnector.prototype.connect = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.mapStateToProps, mapStateToProps = _c === void 0 ? {} : _c, _d = _b.mapGettersToProps, mapGettersToProps = _d === void 0 ? {} : _d, _e = _b.mapDispatchToProps, mapDispatchToProps = _e === void 0 ? {} : _e, _f = _b.mapCommitToProps, mapCommitToProps = _f === void 0 ? {} : _f;
        return function (Component) {
            return {
                functional: true,
                render: function (createElement, context) {
                    return createElement(Component, Object.assign(context.data, {
                        props: Object.assign({}, context.data.props, _this.dataToProps(mapStateToProps, 'state'), _this.dataToProps(mapGettersToProps, 'getters'), _this.functionToProps(mapDispatchToProps, 'dispatch'), _this.functionToProps(mapCommitToProps, 'commit')),
                    }), context.children);
                },
            };
        };
    };
    VuexConnector.prototype.dataToProps = function (map, type) {
        var _this = this;
        if (map === void 0) { map = {}; }
        return Object.keys(map).reduce(function (pre, cur) {
            var option = map[cur];
            var fn;
            switch (typeof option) {
                case 'function':
                    fn = option;
                    break;
                case 'string':
                    fn = function (data) { return data[option]; };
                    break;
            }
            pre[cur] = fn(_this.store[type]);
            return pre;
        }, {});
    };
    VuexConnector.prototype.functionToProps = function (map, type) {
        var _this = this;
        if (map === void 0) { map = {}; }
        return Object.keys(map).reduce(function (pre, cur) {
            var option = map[cur];
            pre[cur] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var fn = _this.store[type];
                return fn.apply(void 0, [option].concat(args));
            };
            return pre;
        }, {});
    };
    return VuexConnector;
}());
exports.default = VuexConnector;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/@xunlei/vuex-connector/lib/index.js
// module id = eOgT
// module chunks = 0